import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Check, ChevronsUpDown } from "lucide-react";

export function MultiSelect({ options, selected, onChange, placeholder = "Alle", testid }) {
  const [open, setOpen] = useState(false);
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const label =
    selected.length === 0
      ? placeholder
      : selected.length === 1
      ? options.find((o) => o.value === selected[0])?.label || selected[0]
      : `${selected.length} valgt`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="flex w-full items-center justify-between rounded-xl bg-white border border-[#EBE8E3] px-3 h-10 text-sm hover:bg-[#FBFAF8] [transition-property:background-color] duration-200">
          <span className={selected.length ? "text-[#1A1919] font-medium truncate" : "text-muted-foreground truncate"}>{label}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-1 rounded-xl w-60" align="start">
        {options.length === 0 ? (
          <p className="px-2 py-3 text-sm text-muted-foreground">Ingen valgmuligheder</p>
        ) : (
          <div className="max-h-64 overflow-y-auto">
            {options.map((o) => {
              const on = selected.includes(o.value);
              return (
                <button
                  key={o.value}
                  type="button"
                  onClick={() => toggle(o.value)}
                  data-testid={`${testid}-opt-${o.value}`}
                  className="flex items-center gap-2.5 w-full px-2 py-2 rounded-lg hover:bg-[#F3F1EC] text-sm text-left [transition-property:background-color] duration-150">
                  <span className={`h-4 w-4 rounded-[5px] border flex items-center justify-center shrink-0 ${on ? "bg-[#A83232] border-[#A83232]" : "border-[#D6D3D1]"}`}>
                    {on && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
                  </span>
                  <span className="flex-1 truncate text-[#1A1919]">{o.label}</span>
                </button>
              );
            })}
          </div>
        )}
        {selected.length > 0 && (
          <button
            type="button"
            onClick={() => onChange([])}
            data-testid={`${testid}-clear`}
            className="mt-1 w-full text-center py-1.5 text-xs font-medium text-muted-foreground hover:text-destructive border-t border-[#EBE8E3] [transition-property:color] duration-150">
            Ryd valg
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
